import { makeStyles } from "@mui/styles";
import * as React from "react";
import { Account, ServiceProviderType } from "@/types";
import { GreyPane } from "@/components/molecules/GreyPane";
import { BankingAccountDetails } from "./BankingAccountDetails";
import { DefaultAccountDetails } from "./DefaultAccountDetails";
import { InsuranceAccountDetails } from "./InsuranceAccountDetails";
import { QuilterAccountRequest } from "./QuilterAccountRequest";

export const RequestDetails: React.FC<{ readonly account: Account }> = ({ account }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <GreyPane title="Request details">
        {(() => {
          switch (account.serviceProvider?.serviceProviderType) {
            case ServiceProviderType.Investments:
              return account.serviceProvider.customForm === "quilter" ? (
                <QuilterAccountRequest account={account} />
              ) : (
                <DefaultAccountDetails account={account} />
              );
            case ServiceProviderType.Banking:
              return <BankingAccountDetails account={account} />;

            case ServiceProviderType.Insurance:
              return <InsuranceAccountDetails account={account} />;

            default:
              return <DefaultAccountDetails account={account} />;
          }
        })()}
      </GreyPane>
    </div>
  );
};

const useStyles = makeStyles((_) => ({
  container: {
    minHeight: "400px",
    backgroundColor: "#ecf2f3",
    borderRadius: "4px",
  },
}));
